/* eslint-disable camelcase */
import { initialFormErrors, errorMessages, formFieldNames } from "@/constants/emlakjet-link";

const getErrorObject = (status, errorText) => ({ status, errorText });

const { PHONE, NAME, EMAIL, HAS_ERROR, INDIVIDUAL_KVKK, STATUS } = formFieldNames;

export const handleFormValidation = (formInputs) => {
  const { name, email, individualKVKK } = formInputs;
  const phoneNumber = formInputs[PHONE];
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  const formErrors = { ...initialFormErrors };
  const { requiredText, invalidEmailText, invalidPhoneText, invalidNameText } = errorMessages;

  const cases = {
    absenceOfFullName: getErrorObject(true, requiredText),
    invalidFullName: getErrorObject(true, invalidNameText),
    validName: getErrorObject(false, ""),
    absenceOfPhone: getErrorObject(true, requiredText),
    invalidPhone: getErrorObject(true, invalidPhoneText),
    validPhone: getErrorObject(false, ""),
    absenceOfEmail: getErrorObject(true, requiredText),
    invalidEmail: getErrorObject(true, invalidEmailText),
    validEmail: getErrorObject(false, ""),
    absenceOfIndividualKVKK: getErrorObject(true, ""),
    validIndividualKVKK: getErrorObject(false, ""),
  };

  if (!name) {
    formErrors[NAME] = cases.absenceOfFullName;
  } else if (name.length < 4 || name.length > 40) {
    formErrors[NAME] = cases.invalidFullName;
  } else {
    formErrors[NAME] = cases.validName;
  }

  if (!phoneNumber) {
    formErrors[PHONE] = cases.absenceOfPhone;
  } else if (phoneNumber.length < 12) {
    formErrors[PHONE] = cases.invalidPhone;
  } else {
    formErrors[PHONE] = cases.validPhone;
  }

  if (!email) {
    formErrors[EMAIL] = cases.absenceOfEmail;
  } else if (!emailRegex.test(email)) {
    formErrors[EMAIL] = cases.invalidEmail;
  } else {
    formErrors[EMAIL] = cases.validEmail;
  }

  if (!individualKVKK) {
    formErrors[INDIVIDUAL_KVKK] = cases.absenceOfIndividualKVKK;
  } else {
    formErrors[INDIVIDUAL_KVKK] = cases.validIndividualKVKK;
  }
  const hasNameError = formErrors[NAME][STATUS];
  const hasPhoneError = formErrors[PHONE][STATUS];
  const hasEmailError = formErrors[EMAIL][STATUS];

  const hasError = Object.values(formErrors).some((error) => error.status);
  if (hasError) formErrors[HAS_ERROR] = true;
  if (!hasError) formErrors[HAS_ERROR] = false;
  return { ...formErrors, hasNameError, hasPhoneError, hasEmailError };
};

export const extractCompanyInfo = (projects) => {
  const project = projects.find((proj) => proj.company);

  if (project && project.company) {
    const {
      id: companyId,
      city: { id: cityId } = {},
      district: { id: districtId } = {},
      commissionEarnings,
      name,
    } = project.company;

    return {
      company: companyId,
      city: cityId,
      district: districtId,
      commissionEarnings,
      name,
    };
  }

  return false;
};

export const getSuffixByCurrency = (currencySymbol) => {
  const suffixes = {
    TL: "'den",
    $: "'dan",
    "€": "'dan",
    "£": "'dan",
  };
  return suffixes[currencySymbol] || "'dan";
};
export const getPaginationItems = ({ convertedIntPage, maximumPageCount, keys }) => {
  let arr = [];
  if (keys.length < 5) {
    arr = keys.slice(1, keys.length);
    arr.push(keys.length);
  } else if (convertedIntPage >= 4 && convertedIntPage + 4 < keys.length) {
    arr = keys.slice(convertedIntPage - 1, convertedIntPage + 2);
  } else if (convertedIntPage < 4) {
    arr = [1, 2, 3, 4, 5];
  } else if (convertedIntPage + 4 === keys.length) {
    arr = keys.slice(keys.length - 5, keys.length - 2);
  } else if (convertedIntPage + 4 > keys.length) {
    arr = keys.slice(keys.length - 4, keys.length);
    arr.push(maximumPageCount);
  }

  const listingPaginationItems = arr || [];

  return listingPaginationItems;
};
